import { createFileRoute } from '@tanstack/react-router'
import { ProjectCreate } from '@/modules/project-hub/pages/ProjectCreate'

export const Route = createFileRoute('/projects/create')({
  component: ProjectCreate,
})
